<template>
  <div id="app" style="font-size:13px;" v-wechat-title="$route.meta.title">
    <loading></loading>
    <!-- <reload v-if="SHOWING"></reload> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import Loading from "@/components/Loading/Loading.vue";
import Reload from "@/components/Reload/Reload.vue";
import { mapState } from "vuex";
export default {
  components: {
    Loading,
    Reload
  },
  computed: {
    ...mapState(["LOADING"]),
    ...mapState(["SHOWING"]),
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
}
input {
  outline: none;
  border: 1px solid #fff;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
@font-face {font-family: "iconfont";
  src: url('//at.alicdn.com/t/font_1927372_sg22s28upve.eot?t=1598316789695'); /* IE9 */
  src: url('//at.alicdn.com/t/font_1927372_sg22s28upve.eot?t=1598316789695#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('data:application/x-font-woff2;charset=utf-8;base64,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') format('woff2'),
  url('//at.alicdn.com/t/font_1927372_sg22s28upve.woff?t=1598316789695') format('woff'),
  url('//at.alicdn.com/t/font_1927372_sg22s28upve.ttf?t=1598316789695') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
  url('//at.alicdn.com/t/font_1927372_sg22s28upve.svg?t=1598316789695#iconfont') format('svg'); /* iOS 4.1- */
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-yiyuan1:before {
  content: "\e80e";
}

.icon-lishi:before {
  content: "\e608";
}

.icon--_bingren:before {
  content: "\e62b";
}

.icon-houtui:before {
  content: "\e710";
}

.icon-id-card:before {
  content: "\e6d7";
}

.icon-StarFilled:before {
  content: "\e64f";
}

.icon--zhensuoguanli:before {
  content: "\e726";
}

.icon-location:before {
  content: "\e611";
}

.icon-shouji:before {
  content: "\e62c";
}

.icon-tixing:before {
  content: "\e600";
}

.icon-close:before {
  content: "\e766";
}

.icon-search1:before {
  content: "\e680";
}

.icon-user:before {
  content: "\e622";
}

</style>



// WEBPACK FOOTER //
// src/App.vue